function initSearch() {
    // Handle input event with delegation
    $('.mrk-search-bar input').unbind('input');
    $('.mrk-search-bar input').on('input', function() {
        const searchValue = $(this).val().toLowerCase();
        const linkList = $(this).parents('.mrk-custom-dropdown').find('.option-list li');
        console.log(searchValue.length, $(this));

        if (searchValue.length === 0) {
            linkList.show();
            return;
        }
        linkList.each(function() {
            const linkText = $(this).text().toLowerCase();
            linkText.includes(searchValue) ? $(this).show() : $(this).hide();
        });
    });
}
function renderBrandProducts(li){
    var url = $(li).attr('value');
    var selector = $(li).parents('.mrk-brand-fragrance-refill').find('.model-select');
    getData(url,selector);
}
function UpdateVariantId(e){
    var _id = $(e).attr('value');
    var price = $(e).attr('price');
    var image = $(e).attr('image');
    $(e).parents('.final-add-to-cart').find('[name="id"]').val(_id);
    $(e).parents('.mrk-card-content').find('.rel-image img').attr('src', image).attr('srcset', image);
    $(e).parents('.card-refill-info').find('.mrk-aroma-product-price').html(price)
}
function updateMeta(li){
    var container = $(li).parents('form');
    const Brand = $(container).find('.selectbottlebrand .selected-value[value]').text();
    const fragrance = $(container).find('.mrk-final-product-list .selected-value[value]').text();
    $(container).find('[name="properties[Fragrance]"]').val(fragrance);
    $(container).find('[name="properties[Brand]"]').val(Brand);
}
function initSelect(){
    $('.mrk-selected-option').unbind('click');
    $('.mrk-custom-dropdown li').unbind('click');
    $('.mrk-selected-option').click(function (e) { 
        e.preventDefault();
        $('.dropdown-wrapper').not($(this).parents('.mrk-custom-dropdown').find('.dropdown-wrapper')).slideUp('fast');
        $(this).parents('.mrk-custom-dropdown').find('.dropdown-wrapper').slideToggle('fast');
        $(this).parents('.mrk-custom-dropdown').find('.mrk-search-bar-input').focus()
    });
    $('.mrk-custom-dropdown li').click(function (e) {
        $(this).parents('.dropdown-wrapper').slideUp('fast');
        var value = $(this).attr('value');
        var text = $(this).text();
        $(this).parents('.mrk-custom-dropdown').find('.selected-value').text(text).attr('value', value);
        if($(this).parents('.mrk-custom-dropdown').hasClass('selectbottlebrand')){
            renderBrandProducts($(this))
        }
        updateMeta($(this));
        if($(this).parents('.mrk-custom-dropdown').hasClass('variant-button')){
            UpdateVariantId($(this))
        }
        enableFinalAddToCart();
    });
    $(document).click(function(e) {
        if (!$(e.target).closest('.mrk-custom-dropdown').length) {
            $('.dropdown-wrapper').slideUp('fast');
        }
    });
}
function enableFinalAddToCart() {
    $('.final-add-to-cart.mrk-brands-and-frangrance-wrap').each(function(){
        const BrandLength = $(this).find('.selectbottlebrand .selected-value[value]').length;
        const checkedLength = $(this).find('.mrk-final-product-list .selected-value[value]').length;
        const variantLength = $(this).find('.variant-button .selected-value[value]').length;
        const isDisabled = checkedLength && BrandLength && variantLength;
        $(this).find('[is="custom-button"]').toggleClass('disabled', !isDisabled);
        if(isDisabled){
            UpdateVariantId();
            $('.mrk-aroma-info').slideDown();
        }
        else{
            $('.mrk-aroma-info').slideUp();
        }
    })
}
function getData(url,selector,callback){
    var callback = callback || function() { };
    $.ajax({
        type: "GET",
        url,
        dataType: "html",
        cache: true,
        beforeSend: function(){
            $(selector).html(`<div class="mrk-loader"><div class="lds-dual-ring"></div></div>`).addClass('mrk-loading');
        },
        success: function (response) {
            selector.html(response).removeClass('mrk-loading');
            callback();
            bindEvents();
        }
    });
}
function bindEvents(){
    initSearch();
    initSelect();
}function getBrands(){
  $('.mrk-brands-list').each(function(){
    var _this = $(this);
    var url = $(this).attr('url');
    $.ajax({
        type: "GET",
        url,
        dataType: "html",
        cache: true,
        success: function (response) {
            $(_this).html(response);
            bindEvents();
        }
    });
  });
}
initSelect();
initSearch();
getBrands();
enableFinalAddToCart();
